import type { SearchResultItemDeliveryCosts } from "@repo/api/catalog/api/schemas/search-result-item-delivery-costs";
import type { DietCatalog, DietCatalogCateringType } from "../types";
import type {
  DietSearchResultsItemType,
  DietSearchResultsType,
} from "../types/diet-search-resilts.type";

// Search results describe a catering without a delivery cost as "undefined",
// while the catalog shape used across the app calls that case "none".
const mapDeliveryCosts = (
  deliveryCosts?: SearchResultItemDeliveryCosts,
): DietCatalogCateringType["deliveryCosts"] => {
  if (!deliveryCosts?.type || deliveryCosts.type === "undefined") {
    return { price: null, type: "none" };
  }

  return { price: deliveryCosts.price ?? null, type: deliveryCosts.type };
};

export const mapDietSearchResultsToDietCatalog = (
  data: DietSearchResultsType,
) => {
  const mappedData: DietCatalog[] = data["hydra:member"].map((item) =>
    mapDietSearchResultsToDietCatalogDetail(item),
  );

  return {
    ...data,
    "hydra:member": mappedData,
  };
};

export const mapDietSearchResultsToDietCatalogDetail = (
  item: DietSearchResultsItemType,
): DietCatalog => {
  return {
    configurationId: item.id || undefined,
    "@id": item["@id"],
    "@type": item["@type"],
    searchResultId: item.id || "",
    basePrice: item.price,
    basePriceNumeric: item.price.toString(),
    calorifics: [
      {
        mealsCaloricValue: [],
        "@id": "",
        "@type": "",
        calories: item.calories,
        numberOfMeals: 0,
        price: 0,
      },
    ],
    catering: {
      id: item.cateringId,
      name: item.cateringName,
      slug: item.cateringSlug,
      logo: {
        url: item.cateringImageUrl,
      },
      firstPossibleOrderDay: "",
      deliveryCosts: mapDeliveryCosts(item.deliveryCosts),
      description: "",
      days: { min: 0, max: 0 },
      disabledDays: [],
      saturdayDelivery: false,
      sundayDelivery: false,
      heroImageUrl: "",
      maximumDaysAllowedToOrderInFuture: null,
    },
    description: item.dietDescription,
    exampleMenu: [],
    id: item.dietId,
    imageUrl: item.dietImageUrl,
    mealTypes: item.meals,
    menuSelection: false,
    minMealTypes: 0,
    name: item.dietName,
    rating: item.rating,
    tags: item.tags,
    availability: item.deliveryAvailability,
    days: { min: 0, unit: "" },
    variants: [],
    discountCodes: item.discountCodes,
    slug: item.dietSlug,
    merchantMealsIds: item.merchantMealsIds || [],
    active: true,
    lengthDiscounts: item.lengthDiscounts,
    isPromoted: item.isPromoted,
  };
};
